@if (visible) {
  <img
    #compassImg
    class="compass"
    src="./images/compas.svg"
    alt="Compass"
    [style.transform]="transformStyle()"
    (click)="onCompassClick()"
  />
}
